import "./views/news/partials/_articleBrick.js";